<template>
  <div>
    <section class="wrapper__billing-p12">
      <h4 class="h4 font-bold mt-3">Configuración General</h4>
      <p>
        Establece la cofiguración de secuencia de los documentos, como el
        entorno de ejecución del firmado
      </p>
      <el-form :model="form" :rules="rules" ref="form">
        <b-row>
          <b-col xs="12" sm="12" md="12">
            <el-form-item prop="woocommerce_emision_point" class="mb-4">
              <SelectEmissionPointsComponent
                @onChangeSelect="onChangeSelectEmissionPoints"
              />
            </el-form-item>
          </b-col>
        </b-row>

        <transition name="fade">
          <div v-if="selectedBusiness">
            <el-form-item prop="environment">
              <slot name="label">
                <label class="font-semi-bold m-0">Modo de firmado</label>
              </slot>

              <div class="">
                <div class="d-flex align-items-center">
                  <el-switch
                    v-model="form.environment"
                    active-color="#3fdbbf"
                    inactive-color="#989aae"
                  >
                  </el-switch>
                  <span class="ml-4 text-color-primary font-bold"
                    >Habilitar modo producción</span
                  >
                </div>
              </div>
            </el-form-item>

            <template v-if="form.environment">
              <p class="font-semi-bold text-color-primary">
                Secuencias de documentos
              </p>
              <el-form-item prop="invoice_sequence">
                <slot name="label">
                  <label class="font-semi-bold m-0">Factura</label>
                </slot>
                <el-input
                  type="text"
                  name=""
                  v-model="form.invoice_sequence"
                ></el-input>
              </el-form-item>

              <el-form-item prop="credit_note_sequence">
                <slot name="label">
                  <label class="font-semi-bold m-0">Nota crédito</label>
                </slot>
                <el-input
                  type="text"
                  name=""
                  v-model="form.credit_note_sequence"
                ></el-input>
              </el-form-item>

              <el-form-item prop="debit_note_sequence">
                <slot name="label">
                  <label class="font-semi-bold m-0">Nota débito</label>
                </slot>
                <el-input
                  type="text"
                  name=""
                  v-model="form.debit_note_sequence"
                ></el-input>
              </el-form-item>

              <el-form-item prop="liquidation_sequence">
                <slot name="label">
                  <label class="font-semi-bold m-0"
                    >Liquidación de Compra</label
                  >
                </slot>
                <el-input
                  type="text"
                  name=""
                  v-model="form.liquidation_sequence"
                ></el-input>
              </el-form-item>

              <el-form-item prop="guide_sequence">
                <slot name="label">
                  <label class="font-semi-bold m-0">Guía de remisión </label>
                </slot>
                <el-input
                  type="text"
                  name=""
                  v-model="form.guide_sequence"
                ></el-input>
              </el-form-item>

              <el-form-item prop="retention_sequence">
                <slot name="label">
                  <label class="font-semi-bold m-0">Retenciones </label>
                </slot>
                <el-input
                  type="text"
                  name=""
                  v-model="form.retention_sequence"
                ></el-input>
              </el-form-item>
            </template>
          </div>
        </transition>

        <div v-if="!selectedBusiness" class="seq-empty-state">
          <i class="el-icon-office-building seq-empty-icon"></i>
          <p class="seq-empty-text">
            Selecciona un negocio para ver y editar su configuración de firmado.
          </p>
        </div>
      </el-form>
    </section>
  </div>
</template>

<script>
import billingsService from "../services/billingsService";
import SelectEmissionPointsComponent from "../../components/SelectNegocios";

export default {
  name: "DocumentSequenceAddComponent",
  data() {
    return {
      selectedBusiness: false,
      form: {
        user_business_e_p_id: null,
        invoice_sequence: 0,
        credit_note_sequence: 0,
        debit_note_sequence: 0,
        guide_sequence: 0,
        retention_sequence: 0,
        liquidation_sequence: 0,
        environment: 0
      },
      rules: {}
    };
  },
  watch: {
    "form.environment"(val) {
      this.form.environment = this.$options.filters.formatBoolean(val);
    }
  },
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    onChangeSelectEmissionPoints({ emissionPointId }) {
      this.selectedBusiness = !!emissionPointId;
      this.resetForm(emissionPointId);
      this.getConfigDocumentSequences(emissionPointId);
      this.form.woocommerce_emision_point = emissionPointId;
    },
    handleSaveClick() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.$store.dispatch("toggleRequestLoading");

            let response = await billingsService
              .updateConfigDocumentSequences(this.form)
              .finally(() => this.$store.dispatch("toggleRequestLoading"));

            const { success, message } = response.data;
            if (success) {
              this.$notifications.success({
                message
              });
              this.$store.dispatch("userUpdate", {
                user_business: {
                  ...this.getUser.user_business,
                  is_production: !!this.form.environment
                }
              });
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    async getConfigDocumentSequences(id = "") {
      try {
        let response = await billingsService.getConfigDocumentSequences(id);
        const { data, success } = response.data;
        if (success) {
          this.form = {
            ...this.form,
            ...data
          };
        }
      } catch (error) {
        return false;
      }
    },
    resetForm() {
      this.form = {
        invoice_sequence: 0,
        credit_note_sequence: 0,
        debit_note_sequence: 0,
        guide_sequence: 0,
        retention_sequence: 0,
        liquidation_sequence: 0,
        environment: 0
      };
    }
  },
  components: {
    SelectEmissionPointsComponent
  },
  mounted() {
    this.$root.$on("negocio:save-signature", this.handleSaveClick);
    this.getConfigDocumentSequences();
  },
  beforeDestroy() {
    this.$root.$off("negocio:save-signature", this.handleSaveClick);
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.seq-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  margin-top: 12px;
}

.seq-empty-icon {
  font-size: 40px;
  color: #c0c4cc;
  margin-bottom: 12px;
}

.seq-empty-text {
  font-size: 13px;
  color: #909399;
  margin: 0;
  max-width: 280px;
}
</style>
